module.exports = __webpack_public_path__ + "img/title-short.22db614d.png";